import React, { useEffect } from 'react';
import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';

import { NewEntryNoti } from '../../../constants';
import { generateRO } from '../../../actions/repairOrder/ro-actions';

import Style from './Style';
import { Toast } from '../../Toast/Toast';
import { createEstimatorApi } from '../../../api/estimator/estimator-apis';

const useStyles = makeStyles(() => Style());

export default function Buttons({
  onCancel,
  selectedVehicle,
  disabled = false,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const { generateROLoading, generateROSuccess, generateROError } = useSelector(
    (state) => state?.ro,
  );

  // success case of generate RO
  useEffect(() => {
    if (generateROSuccess) {
      if (generateROSuccess?.data?.RO?.id) {
        history.push({
          pathname: `/new-repairorder/${generateROSuccess.data.RO.id}?tab=2`,
        });
        window.location.reload();
      }
    }
  }, [generateROSuccess]);

  // error case of generate RO
  useEffect(() => {
    if (generateROError) {
      Toast('error', generateROError || 'Error While Creating RO!');
      // dispatch(clearRoState());
    }
  }, [generateROError]);

  const handleCreateRoEstimator = async (vehicleObj, usedIn) => {
    if (usedIn === 'ro') {
      dispatch(
        generateRO({
          vehicleId: vehicleObj.id,
          customerId: vehicleObj?.customer?.id || null,
        }),
      );
    } else {
      const {
        data: { data },
      } = await createEstimatorApi({
        vehicleId: vehicleObj.id,
        customerId: vehicleObj?.customer?.id || null,
      });
      console.log('>>>>createdEstimate', data);
      if (data?.createdEstimate?.id) {
        history.push({
          pathname: `/estimator/${data?.createdEstimate?.id}`,
        });
        window.location.reload();
      }
      // history.push('/estimator');

      // dispatch({
      //   type: 'SET_SELECTED_CUSTOMER_AND_VEHICLE',
      //   payload: {
      //     customer: vehicleObj?.customer || '',
      //     vehicle: { ...vehicleObj, isNew: true },
      //   },
      // });

      // onCancel();

      // const {
      //   modelYear = '',
      //   vehicleMake = '',
      //   vehicleModel = '',
      //   engineInfo = '',
      // } = vehicleObj;
      // dispatch({
      //   type: 'SET_VEHICLE_INFO_ON_HEADER',
      //   payload:
      //     (modelYear || '') +
      //     ' ' +
      //     (vehicleMake || '') +
      //     ' ' +
      //     (vehicleModel || '') +
      //     ' ' +
      //     (engineInfo || ''),
      // });
    }
  };
  const createEstimateOrRo = (usedIn) => {
    if (selectedVehicle?.id) {
      handleCreateRoEstimator(selectedVehicle, usedIn);
    }
  };
  return (
    <>
      <div className={classes.flex__bw}>
        <Button
          className={clsx(classes.cancel__btn, classes.main__btn)}
          onClick={onCancel}
        >
          Cancel
        </Button>
        <div>
          <Button
            startIcon={<NewEntryNoti />}
            className={clsx(
              classes.estimate__btn,
              classes.main__btn,
              (disabled || generateROLoading) && classes.disabled__action__btn,
            )}
            onClick={() => createEstimateOrRo('estimate')}
            disabled={disabled || generateROLoading}
          >
            Estimate
          </Button>

          <Button
            startIcon={<NewEntryNoti />}
            className={clsx(
              classes.ro__btn,
              classes.main__btn,
              (disabled || generateROLoading) && classes.disabled__action__btn,
            )}
            onClick={() => createEstimateOrRo('ro')}
            disabled={disabled || generateROLoading}
          >
            New RO
            {generateROLoading && (
              <CircularProgress size={12} style={{ marginLeft: '7px' }} />
            )}
          </Button>
        </div>
      </div>
    </>
  );
}
